import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { buildComponentName } from '../utils';
import { getPosition, getCirclePath } from './utils';
import Props from './props';
export default {
  name: buildComponentName('ProgressCircle'),
  props: _objectSpread({}, Props, {
    trailWidth: {
      type: [Number, String],
      default: null
    }
  }),
  computed: {
    radius: function radius() {
      var strokeWidth = this.strokeWidth; // prettier-ignore

      return 50 - strokeWidth / 2;
    },
    circlePath: function circlePath() {
      var gapPosition = this.gapPosition,
          radius = this.radius; // eslint-disable-next-line

      return getCirclePath(getPosition(gapPosition, radius), radius);
    },
    circumference: function circumference() {
      var radius = this.radius;
      return Math.PI * 2 * radius;
    },
    arcLength: function arcLength() {
      var gapDegree = this.gapDegree,
          radius = this.radius; // prettier-ignore

      return gapDegree * Math.PI * radius / 180;
    },
    trailStyle: function trailStyle() {
      var circumference = this.circumference,
          arcLength = this.arcLength,
          trailColor = this.trailColor;
      return {
        stroke: trailColor,
        strokeDasharray: "".concat(circumference - arcLength, "px ").concat(circumference, "px"),
        strokeDashoffset: "-".concat(arcLength / 2, "px"),
        transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s'
      };
    },
    strokeStyle: function strokeStyle() {
      var circumference = this.circumference,
          arcLength = this.arcLength,
          percentage = this.percentage,
          strokeColor = this.strokeColor;
      return {
        stroke: strokeColor,
        // prettier-ignore
        strokeDasharray: "".concat(percentage / 100 * (circumference - arcLength), "px ").concat(circumference, "px"),
        strokeDashoffset: "-".concat(arcLength / 2, "px"),
        transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s'
      };
    }
  },
  render: function render() {
    var h = arguments[0];
    var $attrs = this.$attrs,
        prefixCls = this.prefixCls,
        percentage = this.percentage,
        circlePath = this.circlePath,
        trailWidth = this.trailWidth,
        strokeWidth = this.strokeWidth,
        trailStyle = this.trailStyle,
        strokeStyle = this.strokeStyle,
        strokeLinecap = this.strokeLinecap;

    var svgAttrs = _objectSpread({
      viewBox: '0 0 100 100'
    }, $attrs);

    return h("svg", _mergeJSXProps([{}, {
      class: "".concat(prefixCls, "-circle"),
      attrs: svgAttrs
    }]), [h("path", {
      "class": "".concat(prefixCls, "-circle-trail"),
      "style": trailStyle,
      "attrs": {
        "fill": "none",
        "d": circlePath,
        "stroke-width": trailWidth || strokeWidth
      }
    }), h("path", {
      "class": "".concat(prefixCls, "-circle-path"),
      "style": strokeStyle,
      "attrs": {
        "fill": "none",
        "d": circlePath,
        "stroke-width": percentage === 0 ? 0 : strokeWidth,
        "stroke-linecap": strokeLinecap
      }
    })]);
  }
};